import { createFileRoute, Link } from '@tanstack/react-router';

import { Page } from '@/components/layout/Page';
import { Grid } from '@/components/layout/Grid';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { PageHeader } from '@/components/composed/PageHeader';
import { usePageMeta } from '@/app/shell/use-page-meta';
import { ArrivalIdentity } from '@/features/auth';

export const Route = createFileRoute('/_auth/')({
  component: DashboardPage,
});

function DashboardPage() {
  usePageMeta({ title: 'Dashboard' });
  return (
    <Page>
      <PageHeader title="Dashboard" />
      {/* Arrival identity (F01 R07, AC-c5b105a7): on the authenticated landing,
          show the organization acted for, the role, and whether administrator
          privilege is held — all read from /me. */}
      <ArrivalIdentity />
      <Grid cols={2}>
        <Link to="/invoices" search={{ page: 1, pageSize: 25 }}>
          <Card className="transition-colors hover:border-primary">
            <CardHeader>
              <CardTitle>Invoices</CardTitle>
              <CardDescription>
                Manage billing entities, void, and inspect events.
              </CardDescription>
            </CardHeader>
          </Card>
        </Link>
        <Link to="/clients" search={{ page: 1, pageSize: 25 }}>
          <Card className="transition-colors hover:border-primary">
            <CardHeader>
              <CardTitle>Clients</CardTitle>
              <CardDescription>Manage client records.</CardDescription>
            </CardHeader>
          </Card>
        </Link>
      </Grid>
    </Page>
  );
}
